import { useTheme, useMediaQuery } from "@mui/material";

export const useRadarResponsive = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));

  return {
    outerRadius: isXs ? "84%" : "86%", // The outer radius of the Radar chart
    fontSize: isXs ? 10 : isSm ? 11 : 12,
    polarRadius: isXs ? [20, 50, 80, 110, 140] : [40, 70, 100, 130, 160, 190], // Radii for the PolarGrid circles
    svgScale: isXs ? 0.7 : 0.92, // Scale factor for the SVG background to make it proportional on different screens
  };
};
